<template>
  <div class="pricing-page">
    <div class="contain" :class="{ content: $route.name == 'subscription' }">
      <p class="title" v-if="userDoc && !userDoc.subscription">
        You Must Select a Plan Below To Continue
      </p>
      <p class="title" v-else>Select a Plan below</p>
      <div class="plans">
        <div class="plan" :key="plan.id" v-for="plan in plans">
          <div class="intro">
            <p class="name">{{ plan.name }}</p>
            <p class="price" v-if="!isNaN(plan.price)">
              <template v-if="plan.price">
                <span>$</span>{{ plan.price }}<span class="per">/month</span>
                <div class="plus">
                  <span>+ $499 one time set up fee</span>
                </div>
              </template>
              <template v-else>Free</template>
            </p>
            <p class="price" v-else>
              {{ plan.price ? `${plan.price}` : "Free" }}
              <span></span>
            </p>

            <button
              v-if="userDoc && userDoc.plan_id == plan.id"
              class="btn text_btn"
            >
              Current Plan
            </button>
            <button
              v-else-if="userDoc && !userDoc.plan_id && plan.price == 0"
              class="btn text_btn"
            >
              Current Plan
            </button>
            <button
              v-else-if="!isNaN(plan.price)"
              @click="selectPlan(plan.id)"
              class="btn"
            >
              Select Plan
            </button>
            <button v-else class="btn text_btn call">
              <a href="tel:8883175531">888-317-5531</a>
            </button>
          </div>
          <ul>
            <li>Customize your landing pages with your company logo</li>
            <li>Manage questions and answer options</li>
            <li>Add employees or bulk upload</li>
            <li>Invite visitors</li>
            <li>Manage by locations</li>
            <li>Set automatic reminders and auto sending</li>
            <li>Enable QR reader for faster checking</li>
            <li>See usage reports of employees and visitors</li>
            <li>Platform analytics</li>
            <hr />
            <li v-if="plan.customization == 'logo_only'">Logo Customization</li>
            <template v-else-if="plan.customization == 'full'">
              <li>
                Full Customization Available
              </li>
              <li>
                Integration to your HR platform
              </li>
            </template>
            <li>
              {{ plan.users > -1 ? plan.users : "Unlimited" }} User{{
                plan.users == 1 ? "" : "s"
              }}
            </li>
            <li>
              {{ plan.locations > -1 ? plan.locations : "Unlimited" }}
              Location{{ plan.locations == 1 ? "" : "s" }}
            </li>
            <li>
              {{ plan.forms > -1 ? plan.forms : "Unlimited" }} Form{{
                plan.forms == 1 ? "" : "s"
              }}
            </li>
            <li>
              {{ plan.sms > -1 ? plan.sms : "Unlimited" }} SMS
              {{ plan.sms > -1 ? "/month" : "" }}
            </li>
            <li>
              {{ plan.emails > -1 ? plan.emails : "Unlimited" }} Email{{
                plan.emails == 1 ? "" : "s"
              }}
              {{ plan.emails > -1 ? "/month" : "" }}
            </li>
          </ul>
          <div
            class="btns center"
            v-if="!userDoc || !userDoc.plan_id || userDoc.plan_id !== plan.id"
          >
            <button
              v-if="!isNaN(plan.price)"
              @click="selectPlan(plan.id)"
              class="btn"
            >
              Select Plan
            </button>
            <button v-else class="btn text_btn call">
              <a href="tel:8883175531">888-317-5531</a>
            </button>
          </div>
        </div>
        <div class="plan enterprise">
          <div class="intro">
            <p class="name">Enterprise</p>
            <p class="price">Create Your Own Plan</p>
            <p class="phone">Give us a call at: 888-317-5531</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import { db, auth } from "../firebaseConfig.js";

export default {
  name: "Pricing",
  data() {
    return {};
  },
  created() {},
  computed: {
    plans() {
      return this.$store.getters.getPlans;
    },
    user() {
      return this.$store.getters.getUser;
    },
    userDoc() {
      return this.$store.getters.getUserDoc;
    },
  },
  methods: {
    selectPlan(plan_id) {
      this.$store.commit("setPlanId", plan_id);
      this.$router.push("/billing");
    },
    async setSubscription() {
      await db
        .collection("plan")
        .doc("price_1GuUFKDbbsSH6PM7qW2g7158")
        .set({
          customization: "logo_only",
          display_order: 1,
          emails: 500,
          forms: 1,
          id: "price_1GuUFKDbbsSH6PM7qW2g7158",
          locations: 1,
          name: "Small Sized Business",
          price: 99,
          sms: 10000,
          users: 20,
          visible: true,
        });
      await db
        .collection("plan")
        .doc("price_1GuUFlDbbsSH6PM7AU00mYau")
        .set({
          customization: "logo_only",
          display_order: 2,
          emails: 20000,
          forms: 5,
          id: "price_1GuUFlDbbsSH6PM7AU00mYau",
          locations: 10,
          name: "Medium Sized Business",
          price: 299,
          sms: 100000,
          users: 500,
          visible: true,
        });
    },
  },
};
</script>

<style lang="scss">
.pricing-page {
  .contain {
    .title {
      font-family: "SFProDisplay", sans-serif;
      font-weight: bold;
      margin-top: 0;
      line-height: 1.1;
      font-size: 40px;
      text-align: center;
    }
    .plans {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      flex-wrap: wrap;
      .plan {
        box-shadow: 0 0 8px rgba(128, 128, 128, 0.35);
        background-color: white;
        border-radius: 5px;
        padding: 20px;
        width: 32%;
        margin-bottom: 20px;
        transition: box-shadow 0.3s;
        @media screen and (max-width: 800px) {
          width: 49%;
          margin-bottom: 20px;
        }
        @media screen and (max-width: 600px) {
          width: 100%;
        }
        &:hover {
          box-shadow: 0 0 15px rgba(128, 128, 128, 0.8);
        }
        .intro {
          text-align: center;
          .name {
            font-size: 18px;
            font-weight: 500;
            text-align: center;
            margin-top: 0;
            margin-bottom: 5px;
          }
          .price {
            font-family: "SFProDisplay", sans-serif;
            font-weight: bold;
            text-align: center;
            font-size: 30px;
            margin-top: 0;
            margin-bottom: 20px;
            .per {
              font-size: 17px;
              opacity: 0.7;
              font-weight: normal;
            }
            .plus {
              font-weight: normal;
              font-size: 23px;
              margin: 25px 0;
            }
          }
          .btn {
            margin: 0;
          }
        }
        ul {
          border-top: 2px solid #eaeaea;
          padding: 30px 10px;
          padding-top: 30px;
          margin-top: 30px;
          li {
            font-size: 14px;
            margin-bottom: 10px;
          }
        }
        &.enterprise {
          background: #00bf6f;
          width: 66%;
          color: white;
          @media screen and (max-width: 800px) {
            width: 100%;
          }
        }
      }
    }
    &.content {
      padding: 30px;
      padding-left: 280px;
      padding-top: 100px;
      @media screen and (max-width: 950px) {
        padding-left: 30px;
      }
    }
  }
}

.text_btn.call {
  padding: 0;
  a {
    color: #00bf6f;
  }
}
</style>
